module.exports = __webpack_public_path__ + "img/sand-dune-decal-09.aaeb1cd6.png";